module.exports = __webpack_public_path__ + "static/img/A26.77032841.jpg";